export default __webpack_public_path__ + "static/media/mic-small.4e7bb045.svg";